"use client";

import { Children } from "@/types/types";
import MenuProvider from "./menuContext";
import BlackOpacityProvider from "./blackOpacityContext";
import BookMenuProvider from "./bookMenuContext";
import PopupProvider from "./popupContext";
import LanguageProvider from "./languageContext";
import LanguageUrlProvider from "./languageURLContext";

interface ProvidersProps {
  children: Children;
  lang: string;
}

export function Providers({ children, lang }: ProvidersProps) {
  return (
    <LanguageProvider lang={lang}>
      <MenuProvider>
        <BookMenuProvider>
          <BlackOpacityProvider>
            <LanguageUrlProvider>
              <PopupProvider>{children}</PopupProvider>
            </LanguageUrlProvider>
          </BlackOpacityProvider>
        </BookMenuProvider>
      </MenuProvider>
    </LanguageProvider>
  );
}
